import { DashboardChecksTypeEnum } from "@payping/api";
import { useAppSelector } from "@/utils";

export function useIsSiteDisabled() {
  const checks = useAppSelector((state) => state.user.checks);

  return checks?.siteStatus === DashboardChecksTypeEnum.Confirmed;
}
